import { logInfo } from 'src/utils/logger';

// default values for bleeds as requested on card WB-6989.
const defaultBleedValues = {
  cm: 0.4,
  mm: 4,
  in: 0.125,
  px: 15,
  in_us: 0.157 // is 4mm in inches for print provider
};

module.exports = function (S) {
  const clippathId = 'clip_bleed_area';
  const svgNS = 'http://www.w3.org/2000/svg';
  const svgroot = S.svgroot;
  const canvas = S.canvas;
  let $svgcontent;
  let globalUnit;

  function initBleedObject ($content) {
    $svgcontent = $content;
    const bleed = INKIVE.C.BLEED_VALUES = INKIVE.C.BLEED_VALUES || {};

    if (_.isEmpty(bleed)) {
      setValue('bleedSize');
      setValue('bleedType');
      setValue('bleedUnit');
      setValue('slugSize');
      setValue('slugType');
      setValue('slugUnit');

      function setValue (key) {
        if ($content.data(key)) {
          bleed[key] = $content.data(key);
        }
      }

      const bleedSize = bleed.bleedSize;

      if (bleedSize) {
        bleed.bleedSize = setBleedArray(bleedSize);

        $content.data('bleedSize', bleed.bleedSize);
      }
    } else {
      setBleedValues(bleed.bleedSize, bleed.bleedUnit, bleed.bleedType);
    }

    bleed.slugUnit && bleed.slugSize && fixSlug(bleed);
  }

  function fixSlug (bleed) {
    const book = INKIVE.C.BOOK || {};
    logInfo('Print Bleed Info: extBleed -> fixSlug() initial data', { bleed, book });

    if (!bleed.bleedUnit || !bleed.bleedSize) return;

    const bleedUnit = bleed.bleedUnit;
    const bleedSize = parseFloat(bleed.bleedSize.split(' ')[0]);
    const slugUnit = bleed.slugUnit;
    let slugSize = parseFloat(bleed.slugSize.split(' ')[0]);

    if (bleedUnit === slugUnit) {
      logInfo('Print Bleed Info: extBleed -> fixSlug() case1', { bleed, slugSize, slugUnit, bleedSize, bleedUnit, book });

      slugSize < bleedSize && setBleedValues(bleedSize, bleedUnit, null, true);
    } else {
      logInfo('Print Bleed Info: extBleed -> fixSlug() case2', { bleed, slugSize, slugUnit, bleedSize, bleedUnit, book });

      const slugConvertedSize = convertToNewUnit(slugSize, slugUnit, bleedUnit);

      slugSize = slugConvertedSize < bleedSize
        ? bleedSize
        : slugConvertedSize;
      setBleedValues(slugSize, bleedUnit, null, true);
    }
  }

  function getBleedValues () {
    const bleedValues = INKIVE.C.BLEED_VALUES || {};
    const bleedUnit = globalUnit || INKIVE.FormatFactory.getCurrentSize().unit || bleedValues.bleedUnit || 'px';
    const bleedSize = bleedValues.bleedSize || '0 0 0 0';
    const bleedArray = (bleedSize + '').split(' ');
    const slugSize = bleedValues.slugSize || bleedSize;
    const slugArray = (slugSize + '').split(' ');
    const active = !!document.querySelector('.printGuideLineGroup>.bleed_area');
    const present = !!bleedValues.bleedSize &&
      bleedArray.filter(component => parseFloat(component)).length === 4 &&
      slugArray.filter(component => parseFloat(component)).length === 4;

    return {
      present,
      active,
      manage: active && document.querySelector('header')?.classList.contains('disabled'),
      units: bleedUnit,
      left: parseFloat(bleedArray[0]),
      top: parseFloat(bleedArray[1]),
      right: parseFloat(bleedArray[2]),
      bottom: parseFloat(bleedArray[3]),
      slugLeft: parseFloat(slugArray[0]),
      slugTop: parseFloat(slugArray[1]),
      slugRight: parseFloat(slugArray[2]),
      slugBottom: parseFloat(slugArray[3])
    };
  }

  function setBleedArray (size) {
    const bleedArray = (size + '').split(' ');

    if (bleedArray.length === 1) {
      size = (bleedArray[0] + ' ').repeat(4).trim();
    } else if (bleedArray.length > 4) {
      size = _.first(bleedArray, 4).join(' ');
    }

    return size;
  }

  function setBleedValues (size, unit, type, isSlug) {
    const param = isSlug
      ? 'slug'
      : 'bleed';
    const bleed = INKIVE.C.BLEED_VALUES = INKIVE.C.BLEED_VALUES || {};

    size = setBleedArray(size);

    bleed[param + 'Size'] = size;
    bleed[param + 'Unit'] = unit || 'px';
    bleed[param + 'Type'] = type || 'auto';

    $svgcontent.attr('data-' + param + '-size', bleed[param + 'Size']);
    $svgcontent.attr('data-' + param + '-unit', bleed[param + 'Unit']);
    $svgcontent.attr('data-' + param + '-type', bleed[param + 'Type']);
  }

  function doGenerateNewBleed () {
    const units = globalUnit || INKIVE.FormatFactory.getCurrentSize().unit || 'px';
    const book = INKIVE.C.BOOK || {};
    logInfo('Print Bleed Info: extBleed -> doGenerateNewBleed()', { units, book });

    setBleedValues(defaultBleedValues[units], units);
  }

  function toggleBleedClipper (show, bleed) {
    const $main = $svgcontent.find('g.main');

    recalculateDimensions($('#svgroot').find('#clip_canvas').find('rect.canvasCliper'));
    recalculateDimensions($svgcontent);

    toggleTransform($svgcontent.find('g.background').find('image'));
    toggleTransform($main);

    function recalculateDimensions (element) {
      const aditionFactor = show
        ? -1
        : 1;

      element.attr('x', element.attr('x') + bleed.left * aditionFactor);
      element.attr('y', element.attr('y') + bleed.top * aditionFactor);
      element.attr('width', element.attr('width') - (bleed.left + bleed.right) * aditionFactor);
      element.attr('height', element.attr('height') - (bleed.top + bleed.bottom) * aditionFactor);
    }

    function toggleTransform ($element) {
      if (!$element.length) {
        return;
      }
      const xform = svgroot.createSVGTransform();
      const tlist = svgedit.transformlist.getTransformList($element[0]);

      if (show) {
        xform.setTranslate(bleed.left, bleed.top);
        tlist.appendItem(xform);
      } else {
        if (tlist.numberOfItems > 0) {
          if (tlist.getItem(0).type === SVGTransform.SVG_TRANSFORM_TRANSLATE) {
            tlist.removeItem(0);
          }
        }
      }
    }
  }

  function getBleedInPixels (bleed) {
    function getRoundedValue (val) {
      return Math.round(INKIVE.Helpers.convertUnitsToPixels(val, bleed.units) * 1000) / 1000;
    }

    return {
      left: getRoundedValue(bleed.left, bleed.units),
      top: getRoundedValue(bleed.top, bleed.units),
      right: getRoundedValue(bleed.right, bleed.units),
      bottom: getRoundedValue(bleed.bottom, bleed.units)
    };
  }

  function convertToNewUnit (value, oldUnit, newUnit) {
    const isResizing = document.querySelector('#svgcontent')?.classList.contains('template-resizing');

    if (isResizing && value === defaultBleedValues[oldUnit]) {
      return defaultBleedValues[oldUnit];
    } else {
      const pxValue = INKIVE.Helpers.convertUnitsToPixels(value, oldUnit, true);
      const newValue = INKIVE.Helpers.convertPixelsToUnits(pxValue, newUnit, true);

      return Math.round(newValue * 1000) / 1000;
    }
  }

  return {
    initBleedObject: function (opts) {
      initBleedObject(opts.content);
    },

    showBleedPopupMenu: function () {
      const bleedElement = document.getElementById(clippathId);

      if (bleedElement && !document.querySelector('[data-action=on_bleedsize]')) {
        INKIVE.Menus.elementPopupMenu.render([bleedElement], 'bleed');
      }
    },

    modifyBleedValues: function (opts) {
      opts = opts || {};
      const bleed = getBleedValues();

      setBleedValues(opts.size, bleed.units);

      this.hideBleedClipper({ menuNoHide: true });
      this.showBleedClipper({
        menuNoHide: true,
        manage: true,
        recalculate: true,
        callback: function () {
          const $bleedButton = $('#element-popupmenu').find('a[data-action=on_bleedsize]');
          $bleedButton.find('input').focus();
        }
      });
    },

    generateNewBleed: function (opts) {
      const bleed = getBleedValues();
      if (!bleed.present) {
        doGenerateNewBleed();
      }
    },

    showBleedClipper: function (opts) {
      opts = opts || {};
      opts.zoom || INKIVE.EditorFacade.handle('zoom', 'fit', {
        bleed: true,
        width: canvas.contentW,
        height: canvas.contentH
      });

      const bleed = getBleedValues();
      $svgcontent = $('#svgcontent');

      if (bleed.active && !opts.recalculate) {
        return;
      }

      const bleedPx = getBleedInPixels(bleed);

      opts.manage && INKIVE.Tool.disableUI();

      toggleBleedClipper(true, bleedPx);

      function createClipPathBleed (id) {
        let clippath = document.getElementById(id);
        if (clippath) clippath.remove();
        clippath = document.createElementNS(svgNS, 'clipPath');
        clippath.setAttributeNS(null, 'id', id);

        const rect = document.createElementNS(svgNS, 'rect');
        const clipPathBBox = {
          width: canvas.contentW + 2 * bleedPx.left,
          height: canvas.contentH + 2 * bleedPx.top,
          x: bleedPx.left * -1,
          y: bleedPx.top * -1
        };

        rect.setAttributeNS(null, 'width', canvas.contentW + 2 * bleedPx.left);
        rect.setAttributeNS(null, 'height', canvas.contentH + 2 * bleedPx.top);
        rect.setAttributeNS(null, 'x', '-' + bleedPx.left);
        rect.setAttributeNS(null, 'y', '-' + bleedPx.top);
        clippath.append(rect);
        document.querySelector('#svgroot > defs').append(clippath);
        opts.manage && canvas.runExtensions('showBleedPopupMenu');

        return clipPathBBox;
      }

      const clipPathBBox = createClipPathBleed(clippathId);

      const svgContent = document.getElementById('svgcontent');
      const main = svgContent.querySelector('.main');
      const background = svgContent.querySelector('g.background');
      const backgroundRect = background.querySelector('rect');

      svgContent.style.overflow = 'auto';
      if (main) {
        this.prevClipPath = main.getAttribute('clip-path');
        main.setAttribute('clip-path', `url(#${clippathId})`);
      }

      if (background) {
        background.setAttribute('clip-path', `url(#${clippathId})`);
      }

      if (backgroundRect) {
        backgroundRect.setAttribute('x', clipPathBBox.x);
        backgroundRect.setAttribute('y', clipPathBBox.y);
        backgroundRect.setAttribute('width', clipPathBBox.width);
        backgroundRect.setAttribute('height', clipPathBBox.height);
      }

      toggleBleedClipper(false, bleedPx);
    },

    hideManageBleed: function () {
      INKIVE.Tool.enableUI();
      canvas.clearSelection();
    },

    hideBleedClipper: function (opts) {
      opts = opts || {};

      const bleed = getBleedValues();

      if (!bleed.active) {
        return;
      }

      opts.keepDisabled || INKIVE.Tool.enableUI();

      // Remove clipPath bleed
      const svgContent = document.getElementById('svgcontent');
      const main = svgContent.querySelector('.main');
      const background = svgContent.querySelector('g.background');
      const backgroundRect = background.querySelector('rect');

      if (backgroundRect) {
        backgroundRect.setAttribute('x', 0);
        backgroundRect.setAttribute('y', 0);
        backgroundRect.setAttribute('width', '100%');
        backgroundRect.setAttribute('height', '100%');
      }

      svgContent.style.overflow = '';
      main && main.setAttribute('clip-path', this.prevClipPath);
      background && background.removeAttribute('clip-path');

      INKIVE.Menus.elementPopupMenu.hide();
    },

    getBleedValues: function () {
      return getBleedValues();
    },

    removeBleedValues: function () {
      INKIVE.C.BLEED_VALUES = {};

      const $content = $('#svgcontent');

      $content.attr('data-bleed-size', '');
      $content.attr('data-bleed-type', '');
      $content.attr('data-bleed-unit', '');

      INKIVE.Menus.elementPopupMenu.hide();
    },

    zoomChanged: function () {
      const { active, manage } = getBleedValues();

      if (active) {
        this.hideBleedClipper();
        this.showBleedClipper({ zoom: true, recalculate: true, manage });
      }
    },

    updateUnits: function (unit) {
      globalUnit = unit;

      const bleedObj = INKIVE.C.BLEED_VALUES;

      if (bleedObj && bleedObj.bleedUnit && bleedObj.bleedUnit !== unit) {
        const bleed = getBleedValues();
        let convertedBleed = '';
        let convertedSlug = '';

        convertedBleed += convertToNewUnit(bleed.left, bleedObj.bleedUnit, unit) + ' ';
        convertedBleed += convertToNewUnit(bleed.top, bleedObj.bleedUnit, unit) + ' ';
        convertedBleed += convertToNewUnit(bleed.right, bleedObj.bleedUnit, unit) + ' ';
        convertedBleed += convertToNewUnit(bleed.bottom, bleedObj.bleedUnit, unit);

        convertedSlug += convertToNewUnit(bleed.slugLeft, bleedObj.bleedUnit, unit) + ' ';
        convertedSlug += convertToNewUnit(bleed.slugTop, bleedObj.bleedUnit, unit) + ' ';
        convertedSlug += convertToNewUnit(bleed.slugRight, bleedObj.bleedUnit, unit) + ' ';
        convertedSlug += convertToNewUnit(bleed.slugBottom, bleedObj.bleedUnit, unit);

        setBleedValues(convertedBleed, unit);
        setBleedValues(convertedSlug, unit, null, true);
      }
    },

    getSlugValues: function () {
      const bleed = getBleedValues();
      let slug = '';

      slug += (bleed.slugLeft > bleed.left
        ? bleed.slugLeft
        : bleed.left) + ' ';
      slug += (bleed.slugLeft > bleed.top
        ? bleed.slugLeft
        : bleed.top) + ' ';
      slug += (bleed.slugLeft > bleed.right
        ? bleed.slugLeft
        : bleed.right) + ' ';
      slug += (bleed.slugLeft > bleed.bottom
        ? bleed.slugLeft
        : bleed.bottom);

      return slug;
    },

    setPrintBleed: function ({ size }) {
      return setBleedArray(size);
    },

    getDefaultBleedValues: function () {
      return defaultBleedValues;
    }
  };
};
